"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Date = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Date = function Date() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M11.813 14a2 2 0 012-2h1.5a2 2 0 012 2v1.5a2 2 0 01-2 2h-1.5a2 2 0 01-2-2V14z",
    opacity: "0.64"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.938 2.375a1.375 1.375 0 012.75 0V3.75h8.25V2.375a1.375 1.375 0 112.75 0v1.432a4.126 4.126 0 013.437 4.068v11A4.125 4.125 0 0118 23H5.625A4.125 4.125 0 011.5 18.875v-11a4.126 4.126 0 013.438-4.068V2.375zM18 9.938H5.625a.687.687 0 00-.688.687v8.25c0 .38.308.688.688.688H18c.38 0 .688-.308.688-.688v-8.25A.687.687 0 0018 9.937z",
    clipRule: "evenodd"
  }));
};

exports.Date = Date;